import { render, staticRenderFns } from "./CarbonInput.vue?vue&type=template&id=5bb31efa&scoped=true"
import script from "./CarbonInput.vue?vue&type=script&lang=js"
export * from "./CarbonInput.vue?vue&type=script&lang=js"
import style0 from "./CarbonInput.vue?vue&type=style&index=0&id=5bb31efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb31efa",
  null
  
)

export default component.exports